/// Canonical display formatter for sites — produces
/// "Bacsys Innovations (ACVSS) Coimbatore" when entity + state are
/// set, "Bacsys Innovations" when neither is. Used everywhere a
/// `Site` object is rendered directly (sites list, site pickers).
///
/// Mirror of the Postgres `sites.display_name` generated column so
/// the client matches what the server returns in joined `site_name`
/// fields. Keep the two in sync if the format ever changes.
export function formatSiteName(
  site: { name: string; entity?: string | null; state?: string | null } | null | undefined,
): string {
  if (!site) return ''
  let out = site.name
  if (site.entity && site.entity.trim().length > 0) out += ` (${site.entity.trim()})`
  if (site.state  && site.state.trim().length  > 0) out += ` ${site.state.trim()}`
  return out
}
